import type {BoardItemDragState} from '@github-ui/board-core'
import {createContext, use} from 'react'

import styles from './BoardMoveRefusal.module.css'
import type {SavedViewsBoardItem} from './types'

type GetItemDragState = (item: SavedViewsBoardItem) => BoardItemDragState

/**
 * The drag rule for the board around a card, or `undefined` on a board that moves nothing.
 *
 * A context rather than an argument to `renderCard`, so a change in which cards are moving
 * redraws only the reasons and never the host card.
 */
export const BoardItemDragStateContext = createContext<GetItemDragState | undefined>(undefined)

/**
 * Why a card cannot be moved, as text inside the card. `data-drag-disabled` on the frame is
 * a styling hook that assistive technology cannot read, so the reason has to be written out.
 */
export function BoardMoveRefusal({item}: {item: SavedViewsBoardItem}) {
  const getItemDragState = use(BoardItemDragStateContext)
  const dragState = getItemDragState?.(item)
  if (dragState === undefined || dragState.draggable) return null

  return <p className={styles.moveRefusal}>{dragState.reason}</p>
}
